
import { useState } from "react";
import { Media } from "@/components/media/types";

export const useMemorialSlideshow = (galleryMedia: Media[]) => {
  const [isSlideshow, setIsSlideshow] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const startSlideshow = () => {
    if (galleryMedia.length > 0) {
      setCurrentSlide(0);
      setIsSlideshow(true);
    }
  };

  const handlePrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + galleryMedia.length) % galleryMedia.length);
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % galleryMedia.length);
  };

  return {
    isSlideshow,
    currentSlide,
    startSlideshow,
    handlePrevious,
    handleNext,
    closeSlideshow: () => setIsSlideshow(false)
  };
};
